<div mat-dialog-title>
    <div class="d-flex justify-content-between">
        <p>Delayed Documents</p>
        <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
</div>
<div mat-dialog-content>
    <br>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <button style="float: right;display: flex;" class="btn btn-primary" (click)="copyDelayReason()">Copy All</button>
    </div>
    <br>
    <div class="eip-mt-20" [ngClass]="{'kgrid-fullscreen' : enableFullscreen}">
        <!-- [pageable]="true" [pageSize]="20" -->
        <kendo-grid #docGrid [kendoGridBinding]="gridData" [height]="720" id="respondWorflowLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="true" [filterable]="enableFilter" [scrollable]="true" (mouseover)="onHover($event)" class="form-group-grid auto-complete-equal kg-hover-icon" (edit)="editRowData($event)" (cancel)="cancelRowData($event)" (save)="UpdateRowData($event)">
            <ng-template kendoPagerTemplate>
                <div class="k-pager-left">
                    <kendo-pager-info></kendo-pager-info>
                </div>
                <div class="k-pager-right">
                    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                    <kendo-pager-input></kendo-pager-input>
                    <kendo-pager-next-buttons></kendo-pager-next-buttons>
                </div>
            </ng-template>
            <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                    {{rowIndex+1}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="documentId" title="DRG/Document Id" width="10" hidden="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.documentId}}" eipTooltipPosition="auto">
                        {{dataItem.documentId}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="documentNumber" title="Document Number" width="200">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    <span class="no-wrap" eipTooltip="{{dataItem.documentNumber}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">
                        {{dataItem.documentNumber}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="documentTitle" title="Title" width="200">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    <span class="no-wrap" eipTooltip="{{dataItem.documentTitle}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">
                        {{dataItem.documentTitle}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="revisionNo" title="Revision" width="70">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    <span class="" style="display: block;word-wrap:break-word;white-space: normal;">
                        {{dataItem.revisionNo}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="workflowDescription" title="Workflow" width="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.workflowDescription}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">
                        {{dataItem.workflowDescription}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="taskId" title="Task Id" width="10" hidden="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.taskId}}" eipTooltipPosition="auto">
                        {{dataItem.taskId}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="taskStage" title="Workflow Stage" width="100" id="GrlblStage">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.subWorkflowName}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">
                        {{dataItem.subWorkflowName}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="taskName" title="Workflow Task" width="100" id="GrlblStatus">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.taskName}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">
                        {{dataItem.taskName}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="assignedToId" title="Assigned To Id" width="10" hidden="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.assignedToId}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">
                        {{dataItem.assignedToId}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="assignedToName" title="Assigned To" width="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.assignedToName}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">
                        {{dataItem.assignedToName}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Delay Type" [width]="200">
                <ng-template kendoGridCellTemplate let-column="column" let-dataItem="dataItem" let-rowIndex="rowIndex">
                    <div style="width:100%;display:flex">
                        <div style="width:100%; margin-top:7%;margin-bottom: 1%;">
                            <EIPAutoComplete TextField="commentType" ValueField="id" WaterMarkText="Delay Type *" setId="{{'Delay_Reason_Type'+rowIndex}}" ShowTextValueField='N' [SingleValueBind]="false" [dataSource]='delayReasonList' [IsCascading]='true' [defaultValue]="selectedDocCommentId" (valueChange)='onselectedValueChange($event,dataItem)'>
                            </EIPAutoComplete>
                        </div>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Delay Reason" [width]="250">
                <ng-template kendoGridCellTemplate let-column="column" let-dataItem="dataItem" let-rowIndex="rowIndex">
                    <div style="width:100%;display:flex">
                        <div style="width:100%;margin-top:7%;margin-bottom: 1%;" *ngIf="dataItem.Doccomment_typeRequired">
                            <EIPAutoComplete TextField="IntrcommentType" ValueField="id" WaterMarkText="Internal Reason *" setId="{{'Internal_Reason'+rowIndex}}" ShowTextValueField='N' [SingleValueBind]="false" [dataSource]='internalReasonList' [IsCascading]='true' [defaultValue]="setIntrselectedId" (valueChange)='onIntrValueChange($event,dataItem)'>
                            </EIPAutoComplete>
                        </div>
                        <div style="width:100%;margin-top:7%;margin-bottom: 1%;" *ngIf="dataItem.Doccomment_typeRequired == false">
                            <EIPAutoComplete TextField="ExtrcommentType" ValueField="id" [SingleValueBind]="false" WaterMarkText="External Reason *" setId="{{'External_Reason'+rowIndex}}" ShowTextValueField='N' [dataSource]='externalReasonList' [IsCascading]='true' [defaultValue]="setExtrselectedId" (valueChange)='onExtrValueChange($event,dataItem)'>
                            </EIPAutoComplete>
                        </div>
                        <div style="width:100%;margin-top:7%;margin-bottom: 1%;" *ngIf="dataItem.otherCommentsRequired">
                            <input matInput type="text" placeholder="Enter Comment" [value]="dataItem.selectedCmdType ? dataItem.selectedCmdType:dataItem.comments" (change)="onValueChange($event,dataItem);" style="border-bottom:1px solid black; margin-top: 2%;padding-top: 2%;" required>
                        </div>
                    </div>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>
<div mat-dialog-actions>
    <div class="row justify-content-end flex-grow-1">
        <button class="btn btn-primary eip-ml-10 mr-10 eip-mt-10" id="btnDTNPrepare" (click)="saveDelayReason()"><i class="fa fa-save-as" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Save</button>
    </div>
</div>